import { createSlice } from '@reduxjs/toolkit';
import { getBreachOriginList } from './thunk';

const getOptionLabel = item => item?.name || item?.label || item?.description || item?._id || '';

export const initialState = {
	breachOriginList: [],
	breachOriginListSelect: [],
	isLoadingList: false,
	isSuccess: false,
};

const BreachOriginSlice = createSlice({
	name: 'BreachOrigin',
	initialState,
	reducers: {},
	extraReducers: builder => {
		builder.addCase(getBreachOriginList.pending, state => {
			state.isLoadingList = true;
			state.isSuccess = false;
		});

		builder.addCase(getBreachOriginList.fulfilled, (state, action) => {
			const breachOriginList = action.payload || [];
			state.breachOriginList = breachOriginList;
			state.breachOriginListSelect = breachOriginList.map(item => ({
				item,
				value: item._id,
				label: getOptionLabel(item),
			}));
			state.isLoadingList = false;
			state.isSuccess = true;
		});

		builder.addCase(getBreachOriginList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isSuccess = false;
		});
	},
});

export default BreachOriginSlice.reducer;
